import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e422094"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-container" }
const _hoisted_3 = { class: "bio" }
const _hoisted_4 = { class: "logo-container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text" }
const _hoisted_7 = {
  key: 0,
  class: "social-media"
}
const _hoisted_8 = ["href", "title"]
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "location" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d19549.964374530697!2d31.161375574989783!3d29.980059509806985!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x145845464c6dc685%3A0xeb3d6cd29c15b77e!2sAdmins-Egypt!5e0!3m2!1sen!2seg!4v1658944826311!5m2!1sen!2seg",
    allowfullscreen: "",
    loading: "lazy",
    referrerpolicy: "no-referrer-when-downgrade"
  })
], -1))
const _hoisted_11 = { class: "contact-data" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "text" }
const _hoisted_15 = { class: "copyright" }
const _hoisted_16 = { class: "copyright-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SectionTitle = _resolveComponent("SectionTitle")!
  const _component_CustomDivider = _resolveComponent("CustomDivider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SectionTitle, {
      title: _ctx.t('footer.header')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", { src: _ctx.imgLogo }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.t('footer.bio')), 1),
        (_ctx.socialMediaList)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialMediaList, (social, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createElementVNode("a", {
                    href: social.link,
                    target: "_blank",
                    title: social.title
                  }, [
                    _createElementVNode("img", {
                      src: social.image
                    }, null, 8, _hoisted_9)
                  ], 8, _hoisted_8)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        (_ctx.contactDataList)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.contactDataList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "item"
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("img", {
                    src: item.image
                  }, null, 8, _hoisted_13),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(item.title), 1)
                ]),
                _createElementVNode("ul", null, [
                  (item.list)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.list, (itemList, indexList) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: indexList,
                          class: _normalizeClass(item.phoneNumber ? 'phone-number' : '')
                        }, _toDisplayString(`${itemList}`), 3))
                      }), 128))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_CustomDivider),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t('footer.copyRight')), 1)
    ])
  ]))
}